export const demoRu = {
  // ── DemoPage: Seo ──────────────────────────────────────────────────────────
  'demo.seoTitle': 'Начни сейчас — Входи в Grymwyrd',
  'demo.seoDescription':
    'Раскрути мир, займи место за столом, создай героя Grymwyrd и брось кости — экскурсия по виртуальному столу Grymwyrd.',

  // ── DemoPage: GlobeStep ─────────────────────────────────────────────────────
  'demo.globe.worldAriaLabel': 'Мир Grymwyrd',
  'demo.globe.spinningWorld': 'Мир вращается…',
  'demo.globe.tagline': 'Живой мир ужаса и фантазии',
  'demo.globe.arrivedHeading': 'Регион Greywick',
  'demo.globe.heading': 'Найди своё место в вечной сумраке',
  'demo.globe.subheading': 'Стол ждёт в сердце мира. Займи своё место и создай героя.',
  'demo.globe.enterCta': 'Спустись в Grymwyrd',

  // ── DemoPage: AccountStep ───────────────────────────────────────────────────
  'demo.account.heading': 'Стань частью истории',
  'demo.account.subheading':
    'Создай бесплатный аккаунт, чтобы разблокировать полную энциклопедию Grymwyrd и сохранить своего героя — или войди как гость и начни исследовать прямо сейчас.',
  'demo.account.createAccount': 'Создать аккаунт',
  'demo.account.logIn': 'Войти',
  'demo.account.continueAsGuest': 'Продолжить как гость',

  // ── DemoPage: CreateStep ────────────────────────────────────────────────────
  'demo.create.abilityRollLabel': '{ability} (3d6)',
  'demo.create.initiativeLabel': 'Инициатива',
  'demo.create.lobbyEyebrow': 'Виртуальный стол Grymwyrd · Лобби',
  'demo.create.heading': 'Создай своего героя',
  'demo.create.subheading': 'Персонаж SRD 5.2.1, рождённый в Grymwyrd. Назови его, выбери призвание и брось кости.',
  'demo.create.nameLabel': 'Имя',
  'demo.create.namePlaceholder': 'Кто они становятся?',
  'demo.create.chooseCalling': 'Выбери призвание',
  'demo.create.keyAbility': 'Основное: {ability}',
  'demo.create.abilityScores': 'Характеристики',
  'demo.create.abilityScoresHint': '— кликни, чтобы бросить 3d6',
  'demo.create.rollAbilityAria': 'Бросить {ability} (3d6)',
  'demo.create.keepStandard': 'Или оставь стандартные 10 и погружайся.',
  'demo.create.initiativeResult': 'Инициатива {initiative} — кости упали, стол обращает на тебя внимание…',
  'demo.create.bonesTumble': 'Кости вращаются…',
  'demo.create.rollInitiativeCta': 'Определи инициативу и займи своё место',
  'demo.create.chooseCallingHint': 'Выбери призвание, чтобы занять своё место.',

  // ── DemoTableStep ───────────────────────────────────────────────────────────
  'demo.table.errorHeading': 'Стол не удалось подготовить',
  'demo.table.errorBody': 'Виртуальный стол недоступен прямо сейчас.',
  'demo.table.browseLiveTables': 'Смотреть активные столы вместо этого',
  'demo.table.settingTable': 'Подготавливаю стол…',
  'demo.table.connecting': 'Подключаюсь к столу…',
  'demo.table.heroTable': 'Стол {name}',
  'demo.table.firstTable': 'Твой первый стол',
  'demo.table.diceTrayHeading': 'Лоток для костей',
  'demo.table.initiativeHeading': 'Инициатива',
  'demo.table.initiativePrompt': 'Брось кости, чтобы определить порядок боя.',
  'demo.table.rollForInitiative': 'Определить инициативу',
  'demo.table.vttEyebrow': 'Grymwyrd VTT',
  'demo.table.xcardTitle': 'Остановить игру анонимно',
  'demo.table.xcard': 'X-карточка',
  'demo.table.saveHeroTitle': 'Создай бесплатный аккаунт, чтобы сохранить своего героя',
  'demo.table.saveHero': 'Сохранить героя',
  'demo.table.statusLive': 'В сети',
  'demo.table.statusConnecting': 'Подключение',
  'demo.table.actionLogHeading': 'Журнал действий',
  'demo.table.recentRollsHeading': 'Недавние броски',

  // ── DemoTableStep: dock panel titles ────────────────────────────────────────
  'demo.panel.heroSheet': 'Лист Героя',
  'demo.panel.companion': 'Компаньон',
  'demo.panel.diceTray': 'Лоток для Костей',
  'demo.panel.macros': 'Макросы',
  'demo.panel.diceConsole': 'Консоль Костей',
  'demo.panel.initiative': 'Инициатива',
  'demo.panel.poll': 'Опрос',
  'demo.panel.recentRolls': 'Недавние Броски',
  'demo.panel.reference': 'Справка',
  'demo.panel.chat': 'Чат',
  'demo.panel.handouts': 'Раздаточные',
  'demo.panel.safety': 'Безопасность',
  'demo.panel.sceneAndCues': 'Сцена и Реплики',
  'demo.panel.replay': 'Повтор',
  'demo.panel.recap': 'Резюме',
  'demo.panel.actionLog': 'Журнал Действий',

  // ── DemoTableStep: ActionBar ────────────────────────────────────────────────
  'demo.action.melee': 'Рукопашная',
  'demo.action.cast': 'Колдовство',
  'demo.action.move': 'Движение',
  'demo.action.block': 'Защита',
  'demo.action.chooseTarget': 'Выбери цель для {action}…',
  'demo.action.controlling': 'Управляешь:',
  'demo.action.cannotAct': '{label} не может действовать — выбери отряд, персонажа, транспорт или НПС.',
  'demo.action.selectActionable': 'Выбери объект, чтобы действовать с ним.',
  'demo.action.cancel': 'Отмена',

  // ── DemoTableStep: InitiativeTracker ────────────────────────────────────────
  'demo.tracker.rollingOrder': 'Определяю порядок…',
  'demo.tracker.combatant': 'Боец {n}',
  'demo.tracker.previousTurn': 'Предыдущий ход',
  'demo.tracker.round': 'Раунд {round}',
  'demo.tracker.endCombatTitle': 'Завершить бой',
  'demo.tracker.end': 'Завершить',
  'demo.tracker.nextTurnTitle': 'Следующий ход',
  'demo.tracker.next': 'Далее',
  'demo.tracker.hitPoints': 'Хиты',
  'demo.tracker.reduceHp': 'Снизить хиты {name}',
  'demo.tracker.raiseHp': 'Повысить хиты {name}',
  'demo.tracker.addStatusEffect': 'Добавить эффект состояния',
  'demo.tracker.removeFromOrder': 'Убрать из порядка',
  'demo.tracker.removeFromOrderTitle': 'Убрать из порядка боя',
  'demo.tracker.removeCondition': 'Убрать {name}',
  'demo.tracker.roundsShort': '{n}р',

  // ── DemoTableStep: XCardOverlay ─────────────────────────────────────────────
  'demo.xcard.ariaLabel': 'Стол остановлен',
  'demo.xcard.heading': 'Стол остановлен',
  'demo.xcard.body':
    'Кто-то поднял X-карточку. Останавливаемся, без вопросов и без имён. Когда все готовы, продолжаем.',
  'demo.xcard.resume': 'Готовы — продолжаем',

  // ── DemoTableStep: HandoutsCard ─────────────────────────────────────────────
  'demo.handouts.heading': 'Раздаточные',
  'demo.handouts.titlePlaceholder': 'Название (опционально)',
  'demo.handouts.bodyPlaceholder': 'Заметка, подсказка, текст для чтения…',
  'demo.handouts.push': 'Отправить за стол',
  'demo.handouts.whispered': 'Шёпотом',
  'demo.handouts.dismiss': 'Закрыть раздаточный',

  // ── DemoTableStep: SafetyCard / SafetyList ──────────────────────────────────
  'demo.safety.heading': 'Безопасность',
  'demo.safety.description': 'Границы, которые мы не переходим; пределы, которые мы затемняем. Общие для всего стола, никому не приписываются.',
  'demo.safety.linesLabel': 'Границы (жесткое нет)',
  'demo.safety.veilsLabel': 'Пределы (переход в чёрное)',
  'demo.safety.removeItem': 'Убрать "{item}"',
  'demo.safety.addLinePlaceholder': 'Добавить границу…',
  'demo.safety.addVeilPlaceholder': 'Добавить предел…',
  'demo.safety.addLine': 'Добавить границу',
  'demo.safety.addVeil': 'Добавить предел',

  // ── DemoTableStep: CharacterSheetPanel ──────────────────────────────────────
  'demo.sheet.heading': 'Лист Героя',
  'demo.sheet.hp': 'ХП',
  'demo.sheet.ac': 'КЗ',
  'demo.sheet.classLevel': '{className} · Ур. 1',

  // ── CompanionPanel ──────────────────────────────────────────────────────────
  'demo.companion.heading': 'Устройство-компаньон',
  'demo.companion.description':
    'Подключи телефон или планшет как вспомогательный экран — инициатива, недавние броски и сцена отражаются на устройстве. Можешь отозвать доступ в любой момент.',
  'demo.companion.pairDevice': 'Подключить устройство',
  'demo.companion.qrAriaLabel': 'QR-код подключения компаньона',
  'demo.companion.copied': 'Скопировано',
  'demo.companion.copyLink': 'Скопировать ссылку',
  'demo.companion.revoke': 'Отозвать доступ',

  // ── MacroTray ───────────────────────────────────────────────────────────────
  'demo.macros.heading': 'Макросы для Костей',
  'demo.macros.dismissError': 'Закрыть ошибку',
  'demo.macros.newMacro': 'Новый макрос',
  'demo.macros.namePlaceholder': 'Имя (без точек)',
  'demo.macros.labelPlaceholder': 'Подпись кнопки (опционально)',
  'demo.macros.save': 'Сохранить макрос',
  'demo.macros.noDots': 'Имена макросов не могут содержать точки.',

  // ── PollBoard ───────────────────────────────────────────────────────────────
  'demo.poll.heading': 'Опрос',
  'demo.poll.questionPlaceholder': 'Спросить стол…',
  'demo.poll.optionPlaceholder': 'Вариант {n}',
  'demo.poll.removeOption': 'Убрать вариант {n}',
  'demo.poll.addOption': 'Добавить вариант',
  'demo.poll.openPoll': 'Открыть опрос',
  'demo.poll.live': 'Активен',
  'demo.poll.closed': 'Опрос закрыт',
  'demo.poll.vote': 'Голосовать',
  'demo.poll.closePoll': 'Закрыть опрос',
  'demo.poll.startNewPoll': 'Запустить новый опрос',

  // ── RecapCard ───────────────────────────────────────────────────────────────
  'demo.recap.heading': 'Резюме сессии',
  'demo.recap.tagline': 'История вашего стола, когда пыль осела.',
  'demo.recap.gathering': 'Собираю историю…',
  'demo.recap.getRecap': 'Получить резюме сессии',
  'demo.recap.notableRolls': 'Примечательные броски',
  'demo.recap.copied': 'Скопировано!',
  'demo.recap.share': 'Поделиться',

  // ── ReferenceCard / ReferenceDetail ─────────────────────────────────────────
  'demo.reference.heading': 'Справка',
  'demo.reference.searchPlaceholder': 'Поиск монстра, заклинания, правила…',
  'demo.reference.searchAria': 'Поиск в энциклопедии для общего доступа',
  'demo.reference.typeToSearch': 'Введи хотя бы две буквы, чтобы искать в живой энциклопедии.',
  'demo.reference.searching': 'Ищу…',
  'demo.reference.open': 'Открыть {title}',
  'demo.reference.share': 'Поделиться',
  'demo.reference.dismiss': 'Закрыть справку',
  'demo.reference.backToSearch': 'Вернуться к поиску',
  'demo.reference.loadingContent': 'Загружаю содержимое…',
  'demo.reference.notOwned':
    'У тебя ещё нет этой книги. Полная справка откроется, когда ты добавишь её в свою библиотеку.',
  'demo.reference.contentDown': 'Содержимое недоступно прямо сейчас. Попробуй позже.',
  'demo.reference.noAdditionalContent': 'Нет дополнительного содержимого для этой справки.',
  'demo.reference.noLinkedContent': 'Нет связанного содержимого книги для этой справки.',
  'demo.reference.shareToTable': 'Поделиться со столом',

  // ── ReplayTimeline ──────────────────────────────────────────────────────────
  'demo.replay.heading': 'Повтор',
  'demo.replay.tagline': 'Вернись через сессию по событиям.',
  'demo.replay.loading': 'Загружаю…',
  'demo.replay.loadReplay': 'Загрузить повтор',
  'demo.replay.loadMore': 'Загрузить ещё',

  // ── RollFeed / VisibilityToggle ─────────────────────────────────────────────
  'demo.dice.heading': 'Кости',
  'demo.dice.dismissError': 'Закрыть ошибку',
  'demo.dice.labelPlaceholder': 'Атака (опционально)',
  'demo.dice.roll': 'Бросить',
  'demo.dice.rolledForReal': 'Я бросил их на самом деле',
  'demo.dice.totalPlaceholder': 'Итого (обязательно)',
  'demo.dice.physNotationPlaceholder': '1d20+5 (опционально)',
  'demo.dice.physLabelPlaceholder': 'Подпись (опционально)',
  'demo.dice.logPhysical': 'Записать физический бросок',
  'demo.dice.onTable': '🎲 за столом',
  'demo.dice.private': 'Приватный',
  'demo.dice.public': 'Открытый',
  'demo.dice.rolledPrivately': 'бросок был приватный',
  'demo.dice.exploded': 'разорвался',

  // ── SceneBoard ──────────────────────────────────────────────────────────────
  'demo.scene.heading': 'Сцена и реплики',
  'demo.scene.current': 'Сцена: {scene}',
  'demo.scene.cueSuffix': '— реплика: {cue}',
  'demo.scene.noScene': 'Сцена не установлена',
  'demo.scene.oneShotCues': 'Разовые реплики',

  // ── TableMap ────────────────────────────────────────────────────────────────
  'demo.map.tokenAt': '{label} в {x},{y}',
  'demo.map.tile': 'Клетка {x},{y}',
  'demo.map.fogged': 'В тумане',
  'demo.map.battleMap': 'Боевая карта',
  'demo.map.gm': 'МС',
  'demo.map.noMap': 'Карты нет',
  'demo.map.uploadedMap': 'Загруженная карта',
  'demo.map.uploadTitle': 'Загрузить изображение карты как фон холста',
  'demo.map.reading': 'Читаю…',
  'demo.map.upload': 'Загрузить',
  'demo.map.size': 'Размер',
  'demo.map.shrinkMap': 'Уменьшить карту',
  'demo.map.growMap': 'Увеличить карту',
  'demo.map.widthShort': 'Ш',
  'demo.map.narrowMap': 'Сузить карту',
  'demo.map.widenMap': 'Расширить карту',
  'demo.map.heightShort': 'В',
  'demo.map.shortenMap': 'Укоротить карту',
  'demo.map.heightenMap': 'Удлинить карту',
  'demo.map.fitTitle': 'Сбросить позицию + растянуть по сетке',
  'demo.map.fit': 'Подогнать',
  'demo.map.lock': 'Заблокировать',
  'demo.map.adjust': 'Настроить',
  'demo.map.fogOn': 'Туман ВКЛ — кликни, чтобы отключить',
  'demo.map.fogOff': 'Туман ВЫКЛ — кликни, чтобы включить',
  'demo.map.fog': 'Туман',
  'demo.map.exitPaintTitle': 'Выйти из режима покраски',
  'demo.map.paintTitle': 'Рисовать туман — кликай или перетягивай клетки, чтобы открывать/скрывать',
  'demo.map.exitPaint': 'Выйти из режима',
  'demo.map.paint': 'Рисовать',
  'demo.map.hexGridTitle': 'Шестиугольная сетка — клик для квадратной',
  'demo.map.squareGridTitle': 'Квадратная сетка — клик для шестиугольной',
  'demo.map.hex': 'Шестиугольная',
  'demo.map.zoomOut': 'Отдалить',
  'demo.map.zoomLevel': 'Уровень масштаба',
  'demo.map.zoomIn': 'Приблизить',
  'demo.map.resetView': 'Сбросить вид',
  'demo.map.reset': 'Сбросить',

  // ── DockPanel ───────────────────────────────────────────────────────────────
  'demo.dock.expand': 'Развернуть {title}',
  'demo.dock.collapse': 'Свернуть {title}',

  // ── LeaveTableGuard ─────────────────────────────────────────────────────────
  'demo.leave.ariaLabel': 'Покинуть стол?',
  'demo.leave.heading': 'Покинуть стол?',
  'demo.leave.body':
    'Вы в разгаре игры. Это гостевой стол — если вы уйдёте сейчас, сессия завершится и ваш герой будет потерян.',
  'demo.leave.stay': 'Остаться за столом',
  'demo.leave.leaveAnyway': 'Уйти в любом случае',
}
